import React from "react";
import {Tag, styled} from "@reside/ui";

import {CommitWithResults} from "../types";
import {hasTemplateResultFailure} from "../utils";

const PulsingTag = styled(Tag)`
  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
  }
  animation: pulse 2s ease-in-out infinite;
`;

const STATUS_CONFIG: Record<
  string,
  {color: string; label: string}
> = {
  success: {color: "green100", label: "Success"},
  partial: {color: "orange100", label: "Partial"},
  pending: {color: "gray100", label: "Pending"},
};

function resolveStatus(commit: CommitWithResults): string {
  if (commit.template_results.some(hasTemplateResultFailure)) return "partial";
  return commit.process.status ?? "pending";
}

export const CommitStatusBadge = ({
  commit,
}: {
  commit: CommitWithResults;
}): JSX.Element => {
  const isInProgress = commit.process.ends === null;

  if (isInProgress) {
    return <PulsingTag color="primary">In Progress</PulsingTag>;
  }

  const status = resolveStatus(commit);
  const config = STATUS_CONFIG[status] ?? {
    color: "gray100",
    label: status,
  };

  return <Tag color={config.color as any}>{config.label}</Tag>;
};
